import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { darkColors } from "../../theme/colors";
import { Flex } from "../Box";
import { StyledFooter, StyledIconMobileContainer, StyledToolsContainer } from "./styles";
import { ThemeSwitcher } from "../ThemeSwitcher";
import LangSelector from "../LangSelector/LangSelector";
import { LogoWithTextIcon } from "../Svg";
var MenuItem = function(_param) {
    var items = _param.items, isDark = _param.isDark, toggleTheme = _param.toggleTheme, currentLang = _param.currentLang, langs = _param.langs, setLang = _param.setLang, cakePriceUsd = _param.cakePriceUsd, buyCakeLabel = _param.buyCakeLabel, props = _object_without_properties(_param, [
        "items",
        "isDark",
        "toggleTheme",
        "currentLang",
        "langs",
        "setLang",
        "cakePriceUsd",
        "buyCakeLabel"
    ]);
    return /*#__PURE__*/ _jsx(StyledFooter, _object_spread_props(_object_spread({
        p: [
            "40px 16px",
            null,
            "56px 40px 32px 40px"
        ]
    }, props), {
        justifyContent: "center",
        children: /*#__PURE__*/ _jsxs(Flex, {
            flexDirection: "column",
            width: [
                "100%",
                null,
                "1200px;"
            ],
            children: [
                /*#__PURE__*/ _jsx(StyledIconMobileContainer, {
                    display: [
                        "block",
                        null,
                        "none"
                    ],
                    children: /*#__PURE__*/ _jsx(LogoWithTextIcon, {
                        isDark: true,
                        width: "40px"
                    })
                }),
                /*#__PURE__*/ _jsx(StyledToolsContainer, {
                    order: [
                        1,
                        null,
                        3
                    ],
                    flexDirection: [
                        "column",
                        null,
                        "row"
                    ],
                    justifyContent: "space-between",
                    children: /*#__PURE__*/ _jsxs(Flex, {
                        order: [
                            2,
                            null,
                            1
                        ],
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ _jsx(ThemeSwitcher, {
                                isDark: isDark,
                                toggleTheme: toggleTheme
                            }),
                            /*#__PURE__*/ _jsx(LangSelector, {
                                currentLang: currentLang,
                                langs: langs,
                                setLang: setLang,
                                color: darkColors.textSubtle,
                                dropdownPosition: "top-right"
                            })
                        ]
                    })
                })
            ]
        })
    }));
};
export default MenuItem;
